/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { Grid, TextField, Typography, makeStyles } from '@material-ui/core';
import TableItems, {
  MenuActionItem,
  MenuActions,
  TableCell,
  TableRow,
} from 'components/TableItems';
import i18n from 'i18n';
import {
  getAllApplicationsAutoskyRequest,
  removeClientsApplicationsAutoskyRequest,
  renameClientsApplicationsAutoskyRequest,
} from 'modules/environments/actions';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Permission from 'components/ValidPermission';
import AddIcon from '@material-ui/icons/Add';
import Button from 'components/Button';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { useParams } from 'react-router';
import {
  EnvironmentFields,
  ListAppsFields,
  ListAppsProps,
} from 'modules/environments/interfaces';
import RefreshButton from 'components/RefreshButton';
import { useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import styles, { overrideModal } from '../styles';
import ListApplicationClients from './ListApplicationClients';
import TitleBehavior from '../FormBehavior/TitleBehavior';
import ListApplicationClientsState from './ListApplicationClientsState';
import ListApplicationClientsInclude from './ListApplicationClientsInclude';
import ListApplicationClientsCreate from './ListApplicationClientsCreate';

const useStyles = makeStyles(styles);

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

interface Props {
  applicationsList: ListAppsProps;
  isLoadingApps: boolean;
  environmentSelected: EnvironmentFields | null;
  getAllApplicationsAutoskyRequest: ({ id, query }) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  renameClientsApplicationsAutoskyRequest: ({
    id,
    name,
    newName,
    query,
  }) => void;
  removeClientsApplicationsAutoskyRequest: ({ id, name, query }) => void;
}

const ListApplicationsEnvironment = ({
  applicationsList,
  isLoadingApps,
  environmentSelected,
  getAllApplicationsAutoskyRequest,
  modalClose,
  modalOpen,
  renameClientsApplicationsAutoskyRequest,
  removeClientsApplicationsAutoskyRequest,
}: Props) => {
  const classes = useStyles();

  const {
    query,
    searchValue,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);
  const [refresh, setRefresh] = React.useState(false);
  let newName = '';
  const { id } = useParams<{ id: string }>();

  const getEnvironmentApplications = (refresh = false) => {
    getAllApplicationsAutoskyRequest({
      id,
      query,
    });

    setRefresh(refresh);
  };

  React.useEffect(() => {
    getEnvironmentApplications();
  }, [getAllApplicationsAutoskyRequest, query]);

  const handleRemoveApp = (item: ListAppsFields) => {
    modalOpen({
      title: i18n.t('REMOVE_APP_NAME_KEY', {
        app_name: item?.name,
      }),
      content: i18n.t('REMOVE_APP_CONFIRMATION_KEY', {
        app_name: item?.name,
      }),
      footer: (
        <Grid>
          <Button
            deleteButton
            id="remove-button"
            onClick={() => {
              modalOpen({
                title: i18n.t(
                  'APPLICATIONS_CLIENTS_REMOVE_CONFIRMATION_TITLE_KEY',
                  {
                    app_name: item?.name,
                  }
                ),
                content: (
                  <>
                    <Grid container justify="center">
                      <ErrorOutlineIcon className={classes.warn} />
                    </Grid>
                    <Grid container justify="center">
                      <Typography className={classes.warnText}>
                        {i18n.t(
                          'APPLICATIONS_CLIENTS_REMOVE_CONFIRMATION_KEY',
                          {
                            app_name: item?.name,
                          }
                        )}
                      </Typography>
                    </Grid>
                  </>
                ),
                footer: (
                  <Grid>
                    <Button
                      submitButton
                      id="confirm-remove-button"
                      onClick={() => {
                        removeClientsApplicationsAutoskyRequest({
                          id,
                          name: item?.name,
                          query,
                        });
                        modalClose();
                      }}
                    >
                      {i18n.t('CONFIRM_REMOVE_KEY')}
                    </Button>
                    <Button
                      id="cancel-button"
                      variant="outlined"
                      onClick={modalClose}
                    >
                      {i18n.t('CANCEL_KEY')}
                    </Button>
                  </Grid>
                ),
              });
            }}
          >
            {i18n.t('REMOVE_APP_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const handleRenameApp = (item: ListAppsFields) => {
    modalOpen({
      title: i18n.t('RENAME_APP_KEY', {
        app_name: item?.name,
      }),
      fullWidth: true,
      content: (
        <>
          <Grid container className={classes.changeAccountContainer}>
            <Grid item xs={4}>
              <Typography className={classes.currentAccount}>
                {i18n.t('CURRENT_NAME_KEY')}
                {':'}
              </Typography>
              <Typography className={classes.accountName}>
                {item?.name}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.arrow}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </Grid>
            <Grid item xs={4}>
              <Typography className={classes.newAccount}>
                {i18n.t('NEW_NAME_KEY')}
                {':'}
              </Typography>
              <TextField
                variant="outlined"
                autoFocus
                fullWidth
                className={classes.searchInput}
                onChange={({ target }) => {
                  newName = target.value;
                }}
              />
            </Grid>
          </Grid>
        </>
      ),
      footer: (
        <Grid>
          <Button
            submitButton
            id="confirm-button"
            onClick={() => {
              modalOpen({
                title: i18n.t(
                  'APPLICATIONS_CLIENTS_RENAME_CONFIRMATION_TITLE_KEY',
                  {
                    app_name: item?.name,
                  }
                ),
                content: (
                  <>
                    <Grid container justify="center">
                      <ErrorOutlineIcon className={classes.warn} />
                    </Grid>
                    <Grid container justify="center">
                      <Typography className={classes.warnText}>
                        {i18n.t(
                          'APPLICATIONS_CLIENTS_RENAME_CONFIRMATION_KEY',
                          {
                            app_name: item?.name,
                            new_app_name: newName,
                          }
                        )}
                      </Typography>
                    </Grid>
                  </>
                ),
                footer: (
                  <Grid>
                    <Button
                      submitButton
                      id="confirm-rename-button"
                      onClick={() => {
                        renameClientsApplicationsAutoskyRequest({
                          id,
                          name: item?.name,
                          newName,
                          query,
                        });
                        modalClose();
                      }}
                    >
                      {i18n.t('CONFIRM_RENAME_KEY')}
                    </Button>
                    <Button
                      id="cancel-button"
                      variant="outlined"
                      onClick={modalClose}
                    >
                      {i18n.t('CANCEL_KEY')}
                    </Button>
                  </Grid>
                ),
              });
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  return (
    <>
      <TitleBehavior
        title={i18n.t('ENVIRONMENT_APPS_LISTING_KEY')}
        subtitle={i18n.t('ENVIRONMENT_APPS_LISTING_SUBTITLE_KEY')}
      />
      <Grid container alignItems="center" className={classes.actionsHeader}>
        <Grid container item xs={6}>
          <SearchBar
            id="search-clients"
            isLoading={isLoadingApps}
            searchValue={searchValue}
            handleSearch={handleSearch}
            setSearchValue={setSearchValue}
          />
        </Grid>
        <Grid container item xs={6} justify="flex-end">
          <RefreshButton
            id="btn-refresh"
            onClick={() => getEnvironmentApplications()}
            animate={isLoadingApps}
            disabled={isLoadingApps}
          />
          <Grid item className={classes.addButton}>
            <Button
              startIcon={<AddIcon className={classes.addButtonIcon} />}
              keepButton
              id="include-app-button"
              onClick={() =>
                modalOpen({
                  title: i18n.t('INCLUDE_NEW_APP_KEY'),
                  content: <ListApplicationClientsCreate />,
                  overrideClasses: overrideModal,
                })
              }
            >
              {i18n.t('INCLUDE_NEW_APP_KEY')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <TableItems
          header={
            <>
              <TableCell
                handleOrder={() => handleOrder('name')}
                order
                className={classes.rowAllRows}
              >
                {i18n.t('NAME_KEY')}
              </TableCell>
              <TableCell
                handleOrder={() => handleOrder('client_count')}
                order
                align="center"
                centerTitle
                className={classes.rowAllRowsCount}
              >
                {i18n.t('APPLICATIONS_CLIENTS_COUNT_KEY')}
              </TableCell>

              <TableCell centerTitle className={classes.actionHeader}>
                <Grid>{i18n.t('ACTIONS_KEY')}</Grid>
              </TableCell>
            </>
          }
          renderItems={(item: ListAppsFields, index) => (
            <TableRow key={item?.name}>
              <TableCell className={classes.rowAllRows}>{item?.name}</TableCell>
              <TableCell className={classes.rowAllRowsCount}>
                {item?.client_count}
              </TableCell>
              <TableCell align="center">
                <MenuActions id={`btn-options-apps-${index}`}>
                  <MenuActionItem
                    id="btn-app-details"
                    onClick={() =>
                      modalOpen({
                        title: i18n.t('APPLICATIONS_CLIENTS_MODAL_TITLE_KEY', {
                          app_name: item?.name,
                        }),
                        content: (
                          <ListApplicationClients
                            environmentName={environmentSelected?.name}
                            appName={item?.name}
                          />
                        ),
                      })
                    }
                  >
                    {i18n.t('LOGS_PAGE.DETAILS_KEY')}
                  </MenuActionItem>
                  <Permission value="change_applications_name_environment">
                    <MenuActionItem
                      id="btn-app-rename"
                      onClick={() => handleRenameApp(item)}
                    >
                      {i18n.t('RENAME_KEY')}
                    </MenuActionItem>
                  </Permission>
                  <Permission value="remove_applications_environment">
                    <MenuActionItem
                      id="btn-app-remove"
                      onClick={() => handleRemoveApp(item)}
                    >
                      {i18n.t('REMOVE_APP_KEY')}
                    </MenuActionItem>
                  </Permission>
                  <Permission value="change_applications_state_environment">
                    <MenuActionItem
                      id="btn-app-activate-inactivate"
                      onClick={() =>
                        modalOpen({
                          title: i18n.t(
                            'APPLICATIONS_CLIENTS_CHANGE_STATE_MODAL_TITLE_KEY',
                            {
                              app_name: item?.name,
                            }
                          ),
                          content: (
                            <ListApplicationClientsState appName={item?.name} />
                          ),
                          overrideClasses: overrideModal,
                        })
                      }
                    >
                      {i18n.t('ACTIVATE_INACTIVATE_KEY')}
                    </MenuActionItem>
                  </Permission>
                  <Permission value="create_applications_environment">
                    <MenuActionItem
                      id="btn-app-include"
                      onClick={() =>
                        modalOpen({
                          title: i18n.t(
                            'APPLICATIONS_CLIENTS_INCLUDE_MODAL_TITLE_KEY',
                            {
                              app_name: item?.name,
                            }
                          ),
                          content: (
                            <ListApplicationClientsInclude
                              appName={item?.name}
                            />
                          ),
                          overrideClasses: overrideModal,
                        })
                      }
                    >
                      {i18n.t('INCLUDE_CLIENT_KEY')}
                    </MenuActionItem>
                  </Permission>
                </MenuActions>
              </TableCell>
            </TableRow>
          )}
          data={applicationsList}
          isLoading={!refresh && isLoadingApps}
          onChangePage={handlePageChange}
          onChangeLimit={handleLimitChange}
          notFoundText={i18n.t('APPLICATIONS_PAGE.NO_APPLICATIONS_FOUND_KEY')}
        />
      </Grid>
    </>
  );
};

const mapStateToProps = ({
  environments: { isLoadingApps, applicationsList, environmentSelected },
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
  applicationsList,
  isLoadingApps,
  environmentSelected,
});

export default connect(mapStateToProps, {
  getAllApplicationsAutoskyRequest,
  modalOpen,
  modalClose,
  renameClientsApplicationsAutoskyRequest,
  removeClientsApplicationsAutoskyRequest,
})(ListApplicationsEnvironment);
